import { defineStore } from "pinia";
// import userData from '../views/GoogleLogin.vue'

export const usePartStore = defineStore("part", {
    state: () => ({
        part: null,
    }),

    actions: {
        setPart(part) {
            return this.part = part
        },
        getPart() {
            return this.part
        }
    }
})